export enum DrawerAnchor {
	LEFT = 'left',
	RIGHT = 'right',
	// TOP = 'top',
	// BOTTOM = 'bottom',
}

export enum DrawerVariant {
	PERMANENT = 'permanent',
	TEMPORARY = 'temporary',
}
